import { cn } from "@/lib/utils";

type ProductFiltersProps = {
  categories: string[];
  activeCategory: string;
  onChange: (category: string) => void;
  allLabel?: string;
};

export default function ProductFilters({
  categories,
  activeCategory,
  onChange,
  allLabel = "Tất cả",
}: ProductFiltersProps) {
  return (
    <div data-upbo-src="src/components/ProductFilters.tsx:17" className="flex flex-wrap items-center gap-2">
      <button data-upbo-src="src/components/ProductFilters.tsx:18"
        type="button"
        onClick={() => onChange("all")}
        className={cn(
          "rounded-[var(--radius)] border px-4 py-2 text-sm font-medium transition-colors",
          activeCategory === "all"
            ? "border-[var(--color-accent)] bg-[var(--color-accent)] text-[var(--color-bg)]"
            : "border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-ink)] hover:bg-[var(--color-accent)] hover:text-[var(--color-bg)]"
        )}
      >
        {allLabel}
      </button>
      {categories.map((category) => (
        <button data-upbo-src="src/components/ProductFilters.tsx:31"
          key={category}
          type="button"
          onClick={() => onChange(category)}
          className={cn(
            "rounded-[var(--radius)] border px-4 py-2 text-sm font-medium transition-colors",
            activeCategory === category
              ? "border-[var(--color-accent)] bg-[var(--color-accent)] text-[var(--color-bg)]"
              : "border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-ink)] hover:bg-[var(--color-accent)] hover:text-[var(--color-bg)]"
          )}
        >
          {category}
        </button>
      ))}
    </div>
  );
}
